var map = {
	"./de-CH.json": 1030,
	"./de-DE.json": 4819,
	"./en-CA.json": 6403,
	"./en-GB.json": 5121,
	"./en-US.json": 249,
	"./es-ES.json": 5615,
	"./fr-BE.json": 2850,
	"./fr-CA.json": 5858,
	"./fr-CH.json": 1841,
	"./fr-FR.json": 2239,
	"./it-IT.json": 5800,
	"./ja-JP.json": 8447,
	"./nl-BE.json": 8793,
	"./nl-NL.json": 4936,
	"./pt-BR.json": 4919,
	"./zh-CN.json": 4198
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4891;